export const BUILDERS_CATEGORY_DATA = { category: 'builders_cat', name: 'Требования для Застройщиков' };
